import * as ALL_CONSTANTS from './constant';
export class GetConstantValues {
  public getValueByConstantName(metricName: any) {
    return ALL_CONSTANTS[metricName];
  }
}
